import React from 'react';
import PropTypes from 'prop-types';
import { Page } from 'framework7-react';

import { I18n } from 'Locales';
import { mockFunction } from 'Helpers';
import { NavigationService } from 'Services';
import { AppHeader, Pagination } from 'Components';
import { DAILY_FIGURES_CAMPAIGNS, PAGE_NAMES, TABLE_CONFIG } from 'Constants';

import Charity from './views/Charity';
import Commercial from './views/Commercial';

const handleGoBack = resetTransient => {
  resetTransient();
  NavigationService.goBack({ name: PAGE_NAMES.DAILY_FIGURES });
};

const handlePaginationNavigation = (filters, getAdminDailyFigures, defaultParams) => {
  getAdminDailyFigures({ ...filters, ...defaultParams });
};

const AdminView = ({
  adminDailyFigures = {},
  adminFilters = {},
  dailyFigures = {},
  getAdminDailyFigures = mockFunction,
  resetTransient = mockFunction,
  transient = {},
  updateTransientProps = mockFunction,
  updateUserProps = mockFunction,
  userAdminFilters = {},
  userRole = '',
  view = ''
}) => {
  const { meta = {} } = dailyFigures;
  const { filters, getAdminDailyFiguresLoading } = transient;

  return (
    <Page>
      <AppHeader
        goBack
        hideAvatar
        showMcPins={false}
        title={I18n.t('admin:campaignsViews.adminView')}
        handleClick={handleGoBack.bind(null, resetTransient)}
      />

      <>
        {adminDailyFigures.campaignsName === DAILY_FIGURES_CAMPAIGNS.CHARITY_CAMPAIGNS ? (
          <Charity
            adminFilters={adminFilters}
            dailyFigures={dailyFigures}
            getAdminDailyFigures={getAdminDailyFigures}
            transient={transient}
            updateTransientProps={updateTransientProps}
            updateUserProps={updateUserProps}
            userAdminFilters={userAdminFilters}
            userRole={userRole}
            view={view}
          />
        ) : (
          <Commercial
            adminDailyFigures={adminDailyFigures}
            adminFilters={adminFilters}
            dailyFigures={dailyFigures}
            getAdminDailyFigures={getAdminDailyFigures}
            transient={transient}
            updateTransientProps={updateTransientProps}
            updateUserProps={updateUserProps}
            userAdminFilters={userAdminFilters}
            userRole={userRole}
            view={view}
          />
        )}

        <Pagination
          loading={getAdminDailyFiguresLoading}
          totalNumberOfPages={meta?.total_pages}
          onNavigate={handlePaginationNavigation.bind(null, filters, getAdminDailyFigures)}
          numberOfElements={TABLE_CONFIG.ROWS}
          externalPageNumber={meta?.page}
        />
      </>
    </Page>
  );
};

AdminView.propTypes = {
  adminDailyFigures: PropTypes.object,
  adminFilters: PropTypes.object,
  dailyFigures: PropTypes.object,
  getAdminDailyFigures: PropTypes.func,
  resetTransient: PropTypes.func,
  transient: PropTypes.object,
  updateTransientProps: PropTypes.func,
  updateUserProps: PropTypes.func,
  userAdminFilters: PropTypes.object,
  userRole: PropTypes.string,
  view: PropTypes.string
};

export default AdminView;
